export default "__VITE_ASSET__JjERXXpZ__"